import { PageTitle } from '@/components';
import { useGetDashboardIndicators, useGetMeAdmin } from '@/services';
import { AdminActivityFeed } from './components/AdminActivityFeed';
import { AdminDashboardGrid } from './components/AdminDashboardGrid';

const Dashboard = () => {
	const { data: me, isLoading: isMeLoading } = useGetMeAdmin();
	const isAdmin = me?.type === 'ADMIN';

	const { data: indicators, isLoading: isIndicatorsLoading } =
		useGetDashboardIndicators({
			enabled: isAdmin,
		});

	if (isMeLoading) {
		return null;
	}

	return (
		<section className="animate-fade-in space-y-6 px-4 py-6">
			<div className="space-y-1">
				<PageTitle text="Dashboard" />
				<p className="text-sm text-stone-400">
					Visão geral da plataforma
				</p>
			</div>

			{me?.type === 'SUPPORT' ? (
				<div className="rounded-[1.25rem] border border-stone-100 bg-white p-6 shadow-sm">
					<p className="text-sm text-stone-600">
						Indicadores agregados estão disponíveis apenas para
						contas de administrador. Utilize o menu lateral para
						acessar as demais áreas do painel.
					</p>
				</div>
			) : (
				<div className="grid min-h-[calc(100vh-10rem)] gap-6 lg:grid-cols-[7fr_3fr]">
					<div className="min-w-0">
						<AdminDashboardGrid
							indicators={indicators}
							isLoading={isIndicatorsLoading}
						/>
					</div>

					<div className="min-h-[28rem] min-w-0 lg:sticky lg:top-6 lg:min-h-[calc(100vh-10rem)] lg:self-start">
						<AdminActivityFeed />
					</div>
				</div>
			)}
		</section>
	);
};

export default Dashboard;
